<template>
  <div v-if="currentOffre">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début</span>
                  </td>
                  <td>
                    {{ currentOffre.date_debut }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Poste</span>
                  </td>
                  <td>
                    {{ currentOffre.poste.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Nature du poste</span>
                  </td>
                  <td>
                    {{ currentOffre.nature_poste.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentOffre.document.created_by.prenom
                        ? currentOffre.document.created_by.prenom +
                          ' ' +
                          currentOffre.document.created_by.nom
                        : currentOffre.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date fin</span>
                  </td>
                  <td>
                    {{ currentOffre.date_fin }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Nombre de poste</span>
                  </td>
                  <td>
                    {{ currentOffre.nbre_poste }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Type de contrat</span>
                  </td>
                  <td>
                    {{ currentOffre.contrat_type.nom }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cubes"></i> Formations / diplômes
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <p
                  class="text-dark lead"
                  style="color: black"
                  v-html="currentOffre.diplome_formation"
                ></p>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Expériences
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <p
                  class="text-dark lead"
                  style="color: black"
                  v-html="currentOffre.experience"
                ></p>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card
            class="text-black"
            header-class="bg-silver border-bottom-0"
            no-body
          >
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="mdi mdi-comment-edit mr-0"></i> Fonctions / missions
                </h5>
              </div>
            </template>
            <div class="row editor">
              <div class="col-md-12">
                <vue-editor
                  id="fonction-mission"
                  v-model="currentOffre.fonction_mission"
                  :editorToolbar="VueEditorToolbar"
                  class="fonction-mission"
                  :disabled="true"
                />
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';

export default {
  data() {
    return {
      VueEditorToolbar,
    };
  },
  components: {
    VueEditor,
  },
  computed: {
    ...mapGetters('offreEmploi', ['currentOffre']),
  },
};
</script>

<style scoped></style>
